import { NgModule } from "@angular/core";
import { EntityDataService, EntityServices } from "@ngrx/data";
import { PrescriptionDefinitionRepository } from "./impl/service/repository/prescriptionDefinition.repository";
import { PrescriptionDefinitionDataService } from "./impl/service/repository/prescriptionDefinition.dataservice";

@NgModule({})
export class PrescriptionDefinitionModule {
    constructor(
        entityDataService: EntityDataService,
        entityServices: EntityServices,
        repository: PrescriptionDefinitionRepository,
        dataService: PrescriptionDefinitionDataService
    ) {
        entityDataService.registerServices({
            PrescriptionDefinition: dataService,
        });
        entityServices.registerEntityCollectionServices({
            PrescriptionDefinition: repository,
        });
    }
}